(function($, undefined) {
	
	'use strict';
	var utils;
	var formValidator;
	var homeActivityCards;
	var homeVideoPopup;
	
	var submitForm = function(e) {
		var form = $(this);
		var parent = form.closest('.user-login-form-ctn');
		var err = $('.js-form-error-message', form);
		var success = $('.js-form-success-message', form);
		
		e.preventDefault();
		
		success.slideUp(300);
		formValidator.validateForm(form);
		
		if(!form.hasClass('has-error')) {
			parent.addClass('processing');
			
			if ($('[name=groupCode]', form).length > 0) {
				$('[name=username]', form).val($('[name=groupCode]', form).val() + utils.getUsernameSeparator() + $('[name=tempUsername]', form).val());
			}
			var formData = form.serializeArray();
			var data = {
				ajax: true
			};
			for(var i = 0; i < formData.length;  i++) {
				data[formData[i].name] = formData[i].value;
			}
			
			$.ajax({
				url: form[0].action,
				type: form[0].method,
				data: data,
				complete: function(res) {
					if (res.responseText.indexOf('success') != -1) {
						if (form.attr('data-reload') === 'true') {
							window.location.reload(true);
						} else {
							parent.removeClass('processing');
							success.slideDown(300);
						}
					} else {
						parent.removeClass('processing');
						err.filter('.generic-error').slideDown(300);
						
						if (form.attr('data-email-error') === 'true') {
							form.find('.js-email').removeClass('success').addClass('error');
						} else if (form.attr('data-success-only') != 'true') {
							form.find('input.success').removeClass('success').addClass('error');
						}
					}
				}
			});
		}
	};	
	
	
	var loadAndShowVideoInPopup = function() {
		var btn = $(this);	
		var videoPath = btn.attr('data-video-path');
		var videoElement = homeVideoPopup.find('video')[0];
		videoElement.src = videoPath;
		videoElement.load();
		
		homeVideoPopup.find('.btns-ctn').hide();
		homeVideoPopup.find('.video-ctn').show();
	};
	
	var togglePopupBtns = function() {
		homeVideoPopup.find('.btns-ctn').show();
		homeVideoPopup.find('.video-ctn').hide();	
	};
	
	
	var toggleTeacherSubscribeForm = function() {
		$('.user-login-form-ctn').addClass('hide');
		$('.user-subscribe-form-ctn').removeClass('hide');
	};
	
	var toggleTeacherLoginForm = function() {
		$('.user-login-form-ctn').removeClass('hide');
		$('.user-subscribe-form-ctn').addClass('hide');
	};
	
	var onTeacherSubscribeFormSubmit = function() {
		var btn = $(this);
		var form = $(this).closest('form');
		var ctn = btn.closest('.user-subscribe-form-ctn');
		formValidator.validateForm(form);
		
		form.find('.js-form-error-message.generic-error').slideUp(300);
		if (!form.hasClass('has-error')) {
			ctn.addClass('processing');
			var params = {
				ajax: true,
				loguser: true,
				firstName: $('input[name=firstName]', form).val(),
				lastName: $('input[name=lastName]', form).val(),
				email: $('input[name=email]', form).val(),
				password: $('input[name=password]', form).val(),
				field1: $('input[name=field1]', form).val(),
				field2: $('[name=field2]', form).val()
			};
			$.ajax({
				url: "/action/createAccount",
				method: "post",
				data: params,
				success: function(response) {
					console.log(response);
					if (response.indexOf('success') !== -1) {
						location.reload();
					}
					else {
						ctn.removeClass('processing');
						form.find('.js-form-error-message.generic-error').slideDown(300);
					}
				}
			});
		}
	};
	
	var openHomeHelpPopup = function() {
		var btn = $(this);
		var id = btn.attr('data-popup-id');
		var popup = $('.popup-outer#' + id);
		popup.addClass('visible');
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		formValidator.init();
		var loginForms = $('.user-login-form-ctn form');
		var homeActivityCards = $('.home-activity');
		homeVideoPopup = $('#home-help-video-popup, #help-div-video-popup');
		
		loginForms.on('submit', submitForm);
		$('.activity-link', homeActivityCards).hover(function() {
			$(this).closest('.home-activity').toggleClass('hovered');
		});
		
		$('.user-login-form-ctn .subscribe-btn').on('click', toggleTeacherSubscribeForm);
		$('.user-subscribe-form-ctn .leave-subscribe-btn').on('click', toggleTeacherLoginForm);
		
		$('.teacher-subscribe-form-btn').on('click', onTeacherSubscribeFormSubmit);
		
		$('input[name=loginType]').change(function(){
			var t = $(this);
			var v = t.val();
			
			toggleTeacherLoginForm();
			$('.user-login-form-ctn').removeClass('active');
			$('.user-login-form-ctn[data-id="'+v+'"]').addClass('active');
		});
		
		$('.home-video-btn', homeVideoPopup).on('click', loadAndShowVideoInPopup);
		$('.back-button-ctn', homeVideoPopup).on('click', togglePopupBtns);
		$('.open-home-help-div-popup-btn').on('click', openHomeHelpPopup);

		$(document).on('click', function() {
			$('.site-header-user-ctn').removeClass('active');
		});
		
		if (!$('body').attr('data-has-already-loaded') && ($('body').hasClass('is-student-logged') || $('body').hasClass('is-logged-in'))) {
			utils.saveSessionVariable('hasAlreadyLoaded', 'true');
		}
	};
	
	$(window).ready(function () {
		init();
	});
	
	$(document).ready(function() {
		document.body.style.visibility = 'visible';
	});
	
})(jQuery);
